// Custom inline SVG icons supplied by the brand. Imported as React components
// to keep stroke/fill colors controllable via Tailwind / inline style and
// avoid the cost of an external <img> request per render.

export function CollapseDoubleArrow({ size = 18, className = "", color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M11 7L6 12L11 17M18 7L13 12L18 17"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// AI Planner icon — uses the brand PNG asset (sparkle + side-stars). Rendering
// via <img> keeps the file weight tiny and preserves the original gradient/
// color treatment instead of trying to reproduce it in inline SVG paths.
export function AIPlannerIcon({ size = 18, className = "" }) {
  return (
    <img
      src="/icons/ai-planner.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
      draggable={false}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}
